import { keyframes, Mixins } from '@mui/material';

import { purple, qteHeroGradientBlue } from './colors';

const mixins: Mixins = {
    toolbar: {
        minHeight: 66,
    },
};

export const gradients = {
    primaryPurple: `linear-gradient(339deg, rgba(255,255,255,0) 7%, rgba(255,255,255,0.2) 90%), ${purple[500]}`,
    // QTE dashboard hero "estimate due" card (Quarterly Payments redesign).
    qteHeroBlue: `linear-gradient(180deg, ${qteHeroGradientBlue.from} 0%, ${qteHeroGradientBlue.to} 100%)`,
};

/** Masks: opaque keeps content, transparent fades it. The colour itself never shows. */
const FADE = '48px';
const edgeFade = keyframes`
    from { mask-image: linear-gradient(to right, #000 calc(100% - ${FADE}), transparent); }
    1%, 99% { mask-image: linear-gradient(to right, transparent, #000 ${FADE}, #000 calc(100% - ${FADE}), transparent); }
    to { mask-image: linear-gradient(to right, transparent, #000 ${FADE}); }
`;

/**
 * Fades whichever side of a horizontal scroller still has content past it. Spread onto the scrolling
 * element. Scroll-driven, so inert when nothing overflows and a no-op where unsupported.
 */
export const scrollEdgeFade = {
    '@supports (animation-timeline: scroll())': {
        animation: `${edgeFade} linear both`,
        animationTimeline: 'scroll(x self)',
    },
};

/**
 * On touch screens, grows a small control's hit area to the 44px minimum without moving anything:
 * the extra area is an invisible pseudo-element centred on the control. Mouse layouts are untouched.
 */
export const touchTarget = {
    '@media (pointer: coarse)': {
        position: 'relative',
        '&::after': {
            content: '""',
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: '100%',
            height: '100%',
            minWidth: 44,
            minHeight: 44,
            transform: 'translate(-50%, -50%)',
        },
    },
} as const;

export default mixins;
